import React from "react";
import spinner from "@images/spinner.svg";
import { Box } from "@mui/material";

const OverlayLoadingIndicator = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <Box
      sx={(theme) => ({
        position: "fixed",
        width: "100%",
        height: "100%",
        backgroundColor: theme.palette.overlayIndicator,
        opacity: 0.8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        left: 0,
        zIndex: 1001,
      })}
    >
      <Box component="img" src={spinner} alt="Loading..." sx={{ width: 150 }} />
    </Box>
  );
};

export default OverlayLoadingIndicator;
